/* Requêtes réseau en XMLHttpRequest : un script d'app hérité du thème
   monkeypatche window.fetch (wrapper analytics) et fait échouer les réponses
   HTML des sections — XHR est insensible à ce patch. */
function alfaRequete(url, options) {
  options = options || {};
  return new Promise(function (resoudre, rejeter) {
    var x = new XMLHttpRequest();
    x.open(options.method || 'GET', url);
    if (options.json) x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', options.accept || '*/*');
    x.onload = function () {
      resoudre({
        ok: x.status >= 200 && x.status < 300,
        status: x.status,
        text: x.responseText,
        json: function () { return JSON.parse(x.responseText); }
      });
    };
    x.onerror = function () { rejeter(new Error('réseau')); };
    x.send(options.json ? JSON.stringify(options.json) : null);
  });
}

/* Cartes produit — stepper + ajout panier AJAX.
   Délégation d'événements au document : fonctionne pour toute carte présente
   OU insérée plus tard (scroll infini du plan 2b), sans ré-attachement.
   Sans JS, le <form> poste vers /cart/add (repli intégral) : ceci est une
   amélioration progressive. */
(function () {
  'use strict';

  // Stepper − / +
  document.addEventListener('click', function (e) {
    var moins = e.target.closest('[data-carte-moins]');
    var plus = e.target.closest('[data-carte-plus]');
    if (!moins && !plus) return;
    var stepper = e.target.closest('[data-carte-stepper]');
    var qte = stepper && stepper.querySelector('[data-carte-qte]');
    if (!qte) return;
    var v = parseInt(qte.value, 10) || 1;
    qte.value = Math.min(99, Math.max(1, v + (plus ? 1 : -1)));
  });

  // Sélecteur de variante → met à jour le prix affiché sur la carte
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-carte-variante]');
    if (!sel) return;
    var carte = sel.closest('[data-carte]');
    if (!carte) return;
    var opt = sel.options[sel.selectedIndex];
    var courant = carte.querySelector('.carte-produit__prix-courant');
    var barre = carte.querySelector('.carte-produit__prix-barre');
    if (courant && opt.dataset.prix) courant.textContent = opt.dataset.prix;
    if (barre) {
      // Le prix barré n'existe dans le DOM que si la variante initiale était en
      // promo (limite connue, cf. rapport Task 1) — on le met à jour ou on le
      // masque, sans jamais le créer.
      if (opt.dataset.prixBarre) {
        barre.textContent = opt.dataset.prixBarre;
        barre.style.display = '';
      } else {
        barre.style.display = 'none';
      }
    }
  });

  // Ajout panier AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-carte-form]');
    if (!form) return;
    e.preventDefault();
    var bouton = form.querySelector('[data-carte-ajouter]');
    var texte = form.querySelector('[data-carte-ajouter-texte]');
    var texteInitial = texte ? texte.textContent : '';
    var donnees = new FormData(form);
    if (bouton) bouton.dataset.etat = 'chargement';
    alfaRequete('/cart/add.js', {
      method: 'POST',
      accept: 'application/json',
      json: {
        id: parseInt(donnees.get('id'), 10),
        quantity: parseInt(donnees.get('quantity'), 10) || 1
      }
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function () {
      if (bouton) {
        bouton.dataset.etat = 'ok';
        if (texte && bouton.dataset.texteAjoute) texte.textContent = bouton.dataset.texteAjoute;
      }
      if (window.alfaMajPanier) window.alfaMajPanier();
      document.dispatchEvent(new CustomEvent('alfa:carte-ajout', { detail: { bouton: bouton } }));
      setTimeout(function () {
        if (bouton) delete bouton.dataset.etat;
        if (texte) texte.textContent = texteInitial;
      }, 1600);
    }).catch(function () {
      // Échec réseau/serveur : on RESTE dans l'allée (motto : zéro navigation
      // subie). Le bouton passe en « Réessayer » puis se réarme — le repli
      // HTML natif reste réservé aux navigateurs sans JS (listener absent).
      if (bouton) {
        bouton.dataset.etat = 'erreur';
        if (texte && bouton.dataset.texteErreur) texte.textContent = bouton.dataset.texteErreur;
        setTimeout(function () {
          delete bouton.dataset.etat;
          if (texte) texte.textContent = texteInitial;
        }, 2500);
      }
    });
  });
})();

/* « Déjà au panier » + doggo d'approbation.
   État par variante depuis /cart.js ; rafraîchi au chargement (si des cartes
   sont présentes) et après chaque ajout AJAX. Le doggo surgit brièvement près
   du bouton à l'ajout réussi (gabarit global <template data-alfa-doggo-pop>
   dans theme.liquid). */
(function () {
  'use strict';

  var panierParVariante = {};

  function varianteDeCarte(carte) {
    var sel = carte.querySelector('[data-carte-variante]');
    if (sel) return parseInt(sel.value, 10);
    var cache = carte.querySelector('input[name="id"]');
    return cache ? parseInt(cache.value, 10) : NaN;
  }

  function appliquer() {
    document.querySelectorAll('[data-carte]').forEach(function (carte) {
      var zone = carte.querySelector('[data-carte-au-panier]');
      if (!zone) return;
      var q = panierParVariante[varianteDeCarte(carte)] || 0;
      var texte = zone.querySelector('[data-carte-au-panier-texte]');
      if (q > 0) {
        if (texte) texte.textContent = q + ' ' + (zone.dataset.libelle || '');
        zone.hidden = false;
      } else {
        zone.hidden = true;
      }
    });
  }

  function majDepuisPanier() {
    alfaRequete('/cart.js', { accept: 'application/json' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        panierParVariante = {};
        (cart.items || []).forEach(function (item) {
          panierParVariante[item.variant_id] = (panierParVariante[item.variant_id] || 0) + item.quantity;
        });
        appliquer();
      })
      .catch(function () { /* hors ligne : on garde le dernier état connu */ });
  }

  function doggoPop(bouton) {
    var gabarit = document.querySelector('template[data-alfa-doggo-pop]');
    if (!gabarit || !bouton) return;
    var pop = document.createElement('div');
    pop.className = 'alfa-doggo-pop';
    pop.appendChild(gabarit.content.cloneNode(true));
    var r = bouton.getBoundingClientRect();
    pop.style.left = (r.right - 40) + 'px';
    pop.style.top = (r.top - 46) + 'px';
    document.body.appendChild(pop);
    setTimeout(function () { pop.remove(); }, 950);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-carte]')) majDepuisPanier();
  });
  document.addEventListener('alfa:carte-ajout', function (e) {
    majDepuisPanier();
    doggoPop(e.detail && e.detail.bouton);
  });
  // Cartes insérées par le scroll infini : leur état « au panier » sans refetch.
  document.addEventListener('alfa:cartes-ajoutees', appliquer);
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-carte-variante]')) appliquer();
  });
})();

/* Scroll infini des allées — IntersectionObserver sur le lien « Voir plus »
   (repli sans JS intact : le lien navigue). Charge la page suivante via la
   Section Rendering API ~2 écrans avant la fin, append les cartes (la
   délégation du 2a couvre les nouvelles cartes), remplace la sentinelle par
   celle du fragment — ou par le bloc de fin (doggo) sur la dernière page. */
(function () {
  'use strict';
  var enCours = false;
  var io;

  function conteneur() { return document.querySelector('[data-liste-infinie]'); }

  function chargerSuite(sentinelle) {
    if (enCours) return;
    enCours = true;
    sentinelle.dataset.chargement = '1';
    var url = new URL(sentinelle.href, location.origin);
    url.searchParams.set('section_id', conteneur().dataset.sectionId);
    alfaRequete(url.toString(), { accept: 'text/html' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nouvelles = doc.querySelector('[data-liste-cartes]');
        // Fragment sans cartes (session expirée, page verrouillée, erreur
        // serveur rendue en HTML) : on garde la sentinelle telle quelle —
        // l'acheteur peut réessayer, on ne le laisse JAMAIS sans issue.
        if (!nouvelles || !nouvelles.querySelector('[data-carte]')) {
          delete sentinelle.dataset.chargement;
          return;
        }
        var cible = document.querySelector('[data-liste-cartes]');
        while (nouvelles.firstElementChild) {
          cible.appendChild(nouvelles.firstElementChild);
        }
        var ancienne = document.querySelector('[data-liste-sentinelle]');
        var suivante = doc.querySelector('[data-liste-sentinelle]');
        var fin = doc.querySelector('[data-liste-fin]');
        if (suivante && ancienne) { ancienne.replaceWith(suivante); brancher(); }
        else if (fin && ancienne) { ancienne.replaceWith(fin); }
        else if (ancienne) { ancienne.remove(); }
        document.dispatchEvent(new CustomEvent('alfa:cartes-ajoutees'));
      })
      .catch(function () { delete sentinelle.dataset.chargement; /* le lien reste cliquable */ })
      .finally(function () { enCours = false; });
  }

  function brancher() {
    var s = document.querySelector('[data-liste-sentinelle]');
    if (!s) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) chargerSuite(e.target); });
    }, { rootMargin: '1200px 0px' });
    io.observe(s);
    s.addEventListener('click', function (e) { e.preventDefault(); chargerSuite(s); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (conteneur()) brancher();
  });
})();

/* Barre haute du rayon — tiroir des allées : ouverture/fermeture (clic
   extérieur et Échap ferment), et téléportation douce si la page porte
   l'ancre #allee-<handle> (mode rayon) au lieu d'une navigation. */
(function () {
  'use strict';

  function fermer(toggle, tiroir) {
    toggle.setAttribute('aria-expanded', 'false');
    tiroir.hidden = true;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-rayon-allees-toggle]');
    var conteneur = document.querySelector('[data-rayon-bas]');
    if (!conteneur) return;
    var tiroir = conteneur.querySelector('[data-rayon-allees]');
    var toggleRef = conteneur.querySelector('[data-rayon-allees-toggle]');
    if (!tiroir || !toggleRef) return;

    if (toggle) {
      var ouvert = toggleRef.getAttribute('aria-expanded') === 'true';
      toggleRef.setAttribute('aria-expanded', String(!ouvert));
      tiroir.hidden = ouvert;
      return;
    }

    // Téléportation : une allée dont l'ancre existe sur la page (mode rayon).
    var allee = e.target.closest('[data-rayon-allee]');
    if (allee) {
      var ancre = document.getElementById('allee-' + allee.dataset.rayonAllee);
      if (ancre) {
        e.preventDefault();
        fermer(toggleRef, tiroir);
        ancre.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return; // pas d'ancre → navigation normale du lien
    }

    // Clic hors du conteneur : fermer.
    if (!e.target.closest('[data-rayon-bas]') && toggleRef.getAttribute('aria-expanded') === 'true') {
      fermer(toggleRef, tiroir);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var conteneur = document.querySelector('[data-rayon-bas]');
    if (!conteneur) return;
    var toggle = conteneur.querySelector('[data-rayon-allees-toggle]');
    var tiroir = conteneur.querySelector('[data-rayon-allees]');
    if (toggle && tiroir && toggle.getAttribute('aria-expanded') === 'true') fermer(toggle, tiroir);
  });
})();

/* Recherche DANS l'allée — filtre en direct les cartes de la liste.
   ≥ 2 caractères : on s'assure d'abord que TOUTE l'allée est chargée
   (boucle Section Rendering API, cap 20 pages), puis on masque/affiche par
   correspondance de titre normalisé (sans accents). Effacer restaure tout.
   Le rail promos, l'en-tête de tri, la sentinelle et la fin s'effacent
   pendant un filtre (contexte), et reviennent après. */
(function () {
  'use strict';

  function normaliser(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function toutCharger() {
    var s = document.querySelector('[data-liste-sentinelle]');
    if (!s) return Promise.resolve();
    var conteneur = document.querySelector('[data-liste-infinie]');
    var pages = 0;
    function suivante(href) {
      if (!href || pages >= 20) return Promise.resolve();
      pages += 1;
      var url = new URL(href, location.origin);
      url.searchParams.set('section_id', conteneur.dataset.sectionId);
      return alfaRequete(url.toString(), { accept: 'text/html' }).then(function (r) {
        if (!r.ok) return;
        var doc = new DOMParser().parseFromString(r.text, 'text/html');
        var nouvelles = doc.querySelector('[data-liste-cartes]');
        if (!nouvelles || !nouvelles.querySelector('[data-carte]')) return;
        var cible = document.querySelector('[data-liste-cartes]');
        while (nouvelles.firstElementChild) cible.appendChild(nouvelles.firstElementChild);
        var sent = doc.querySelector('[data-liste-sentinelle]');
        var actuelle = document.querySelector('[data-liste-sentinelle]');
        if (sent) { return suivante(sent.getAttribute('href')); }
        var fin = doc.querySelector('[data-liste-fin]');
        if (actuelle) { if (fin) actuelle.replaceWith(fin); else actuelle.remove(); }
        document.dispatchEvent(new CustomEvent('alfa:cartes-ajoutees'));
      });
    }
    var href = s.getAttribute('href');
    if (s) s.remove(); // le filtre prend le relais de la liste
    return suivante(href);
  }

  function elementsContexte() {
    return document.querySelectorAll('.promos-allee, .liste-infinie__entete, [data-liste-sentinelle], [data-liste-fin]');
  }

  function etatVide(visible) {
    var bloc = document.querySelector('.rayon-recherche-vide');
    if (visible && !bloc) {
      bloc = document.createElement('div');
      bloc.className = 'rayon-recherche-vide';
      var gabarit = document.querySelector('template[data-alfa-doggo-pop]');
      if (gabarit) bloc.appendChild(gabarit.content.cloneNode(true));
      var champ = document.querySelector('[data-rayon-recherche]');
      var p = document.createElement('p');
      p.textContent = champ ? champ.dataset.aucunResultat || '' : '';
      bloc.appendChild(p);
      var cible = document.querySelector('[data-liste-cartes]');
      if (cible) cible.parentNode.insertBefore(bloc, cible.nextSibling);
    } else if (!visible && bloc) {
      bloc.remove();
    }
  }

  var minuterie;
  document.addEventListener('input', function (e) {
    var champ = e.target.closest('[data-rayon-recherche]');
    if (!champ) return;
    clearTimeout(minuterie);
    minuterie = setTimeout(function () {
      var q = normaliser(champ.value.trim());
      var compte = document.querySelector('[data-rayon-recherche-compte]');
      if (q.length < 2) {
        document.querySelectorAll('[data-recherche-cachee]').forEach(function (el) { el.removeAttribute('data-recherche-cachee'); });
        etatVide(false);
        if (compte) compte.hidden = true;
        return;
      }
      toutCharger().then(function () {
        var n = 0;
        document.querySelectorAll('[data-liste-cartes] [data-carte]').forEach(function (carte) {
          var nom = normaliser((carte.querySelector('.carte-produit__nom') || {}).textContent);
          var visible = nom.indexOf(q) !== -1;
          if (visible) { carte.removeAttribute('data-recherche-cachee'); n += 1; }
          else carte.setAttribute('data-recherche-cachee', '');
        });
        elementsContexte().forEach(function (el) { el.setAttribute('data-recherche-cachee', ''); });
        etatVide(n === 0);
        if (compte) {
          compte.textContent = n;
          compte.hidden = false;
        }
      });
    }, 250);
  });
})();

/* Barre haute escamotable — disparaît en défilant vers le bas, réapparaît
   dès qu'on remonte. Jamais cachée quand la recherche a le focus. Le bas
   reste persistant (barre de navigation) ; pour l'escamoter aussi, il
   suffirait d'ajouter sa section wrapper à `barres` ci-dessous. */
(function () {
  'use strict';
  var derniereY = 0;
  var barres = [];

  document.addEventListener('DOMContentLoaded', function () {
    var haut = document.querySelector('[data-rayon-haut]');
    if (!haut) return;
    var wrapper = haut.closest('.shopify-section') || haut.parentElement;
    wrapper.classList.add('alfa-barre-escamotable');
    barres = [wrapper];
    derniereY = window.scrollY;

    // Traitement direct (pas de requestAnimationFrame : suspendu dans les
    // WebViews inactives, ce qui gèlerait l'escamotage). Les événements
    // scroll sont déjà coalescés par le navigateur ; le travail est trivial.
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var delta = y - derniereY;
      derniereY = y;
      var champ = document.querySelector('[data-rayon-recherche]');
      if (champ && document.activeElement === champ) return; // recherche en cours
      if (y > 90 && delta > 4) {
        barres.forEach(function (b) { b.classList.add('alfa-barre-cachee'); });
      } else if (delta < -4 || y <= 90) {
        barres.forEach(function (b) { b.classList.remove('alfa-barre-cachee'); });
      }
    }, { passive: true });
  });
})();

window.alfaRequete = alfaRequete;

/* Fiche produit — points de galerie (position au scroll, traitement direct
   sans rAF) et radios de variantes (maj du prix affiché, comme le select). */
(function () {
  'use strict';

  document.addEventListener('scroll', function (e) {
    var galerie = e.target && e.target.closest && e.target.closest('[data-fiche-galerie]');
    if (!galerie) return;
    var points = document.querySelectorAll('[data-fiche-points] .fiche__point');
    if (!points.length) return;
    var index = Math.round(galerie.scrollLeft / galerie.clientWidth);
    points.forEach(function (p, i) { p.classList.toggle('fiche__point--actif', i === index); });
  }, true);

  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-fiche-radio]');
    if (!radio) return;
    var prix = document.querySelector('[data-fiche-prix]');
    var barre = document.querySelector('[data-fiche-prix-barre]');
    if (prix && radio.dataset.prix) prix.textContent = radio.dataset.prix;
    if (barre) {
      if (radio.dataset.prixBarre) { barre.textContent = radio.dataset.prixBarre; barre.style.display = ''; }
      else { barre.style.display = 'none'; }
    }
  });
})();

/* Accordéons de texte génériques (home « Comment ça fonctionne ? », FAQ…).
   Délégation : tout bouton [data-accordeon-toggle] bascule son aria-controls. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-accordeon-toggle]');
    if (!t) return;
    var cible = document.getElementById(t.getAttribute('aria-controls'));
    if (!cible) return;
    var ouvert = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!ouvert));
    cible.hidden = ouvert;
  });
})();

/* Ma liste d'épicerie — mécanique maison (remplace la wishlist Froonze).
   localStorage (clé alfa-liste) : [{handle, url, titre, image, format,
   variante}]. Bouton fiche [data-liste-bouton] (deux libellés commutés en
   CSS par aria-pressed), page [data-liste-conteneur] rendue depuis le
   <template>. Délégation au document, comme le reste du fichier. */
(function () {
  var CLE = 'alfa-liste';

  function lire() {
    try { return JSON.parse(localStorage.getItem(CLE)) || []; }
    catch (e) { return []; }
  }

  function ecrire(liste) {
    try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) { return; }
    document.dispatchEvent(new CustomEvent('alfa:liste-maj', { detail: { taille: liste.length } }));
  }

  function dedans(handle) {
    return lire().some(function (x) { return x.handle === handle; });
  }

  /* — Bouton de la fiche — */
  function majBoutons() {
    var boutons = document.querySelectorAll('[data-liste-bouton]');
    for (var i = 0; i < boutons.length; i++) {
      boutons[i].setAttribute('aria-pressed', dedans(boutons[i].getAttribute('data-liste-handle')) ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-liste-bouton]');
    if (!b) return;
    var handle = b.getAttribute('data-liste-handle');
    var liste = lire();
    if (dedans(handle)) {
      liste = liste.filter(function (x) { return x.handle !== handle; });
    } else {
      liste.push({
        handle: handle,
        url: b.getAttribute('data-liste-url'),
        titre: b.getAttribute('data-liste-titre'),
        image: b.getAttribute('data-liste-image'),
        format: b.getAttribute('data-liste-format'),
        variante: b.getAttribute('data-liste-variante')
      });
    }
    ecrire(liste);
    majBoutons();
  });

  /* — Page « Ma liste d'épicerie » — */
  function rendre() {
    var conteneur = document.querySelector('[data-liste-conteneur]');
    if (!conteneur) return;
    var modele = document.querySelector('[data-liste-modele]');
    var vide = document.querySelector('[data-liste-vide]');
    var liste = lire();
    conteneur.textContent = '';
    if (vide) vide.hidden = liste.length > 0;
    if (!modele) return;
    liste.forEach(function (item) {
      var noeud = modele.content.cloneNode(true);
      var article = noeud.querySelector('article');
      article.setAttribute('data-liste-handle', item.handle || '');
      article.setAttribute('data-liste-variante', item.variante || '');
      var liens = noeud.querySelectorAll('[data-modele-lien]');
      for (var i = 0; i < liens.length; i++) liens[i].href = item.url || '#';
      var image = noeud.querySelector('[data-modele-image]');
      if (item.image) { image.src = item.image; } else { image.remove(); }
      noeud.querySelector('[data-modele-titre]').textContent = item.titre || item.handle;
      var format = noeud.querySelector('[data-modele-format]');
      if (item.format) { format.textContent = item.format; } else { format.remove(); }
      conteneur.appendChild(noeud);
    });
  }

  document.addEventListener('click', function (e) {
    var retirer = e.target.closest('[data-liste-retirer]');
    if (retirer) {
      var article = retirer.closest('[data-liste-handle]');
      var handle = article && article.getAttribute('data-liste-handle');
      ecrire(lire().filter(function (x) { return x.handle !== handle; }));
      rendre();
      majBoutons();
      return;
    }
    var panier = e.target.closest('[data-liste-panier]');
    if (panier) {
      var art = panier.closest('[data-liste-variante]');
      var variante = art && art.getAttribute('data-liste-variante');
      if (!variante) return;
      panier.disabled = true;
      alfaRequete('/cart/add.js', {
        method: 'POST',
        json: { id: parseInt(variante, 10), quantity: 1 },
        accept: 'application/json'
      }).then(function (r) {
        panier.disabled = false;
        panier.setAttribute('data-etat', r.ok ? 'ok' : 'erreur');
        setTimeout(function () { panier.removeAttribute('data-etat'); }, 1800);
        if (r.ok) {
          if (window.alfaMajPanier) window.alfaMajPanier();
          document.dispatchEvent(new CustomEvent('alfa:carte-ajout', { detail: { bouton: panier } }));
        }
      }).catch(function () {
        panier.disabled = false;
        panier.setAttribute('data-etat', 'erreur');
        setTimeout(function () { panier.removeAttribute('data-etat'); }, 1800);
      });
    }
  });

  /* Autre onglet ou fenêtre : la liste reste juste partout. */
  window.addEventListener('storage', function (e) {
    if (e.key !== CLE) return;
    majBoutons();
    rendre();
  });

  majBoutons();
  rendre();
  window.alfaListe = { lire: lire, dedans: dedans };
})();

/* Paniers sauvegardés — mécanique maison (remplace l'app savedcart).
   localStorage (clé alfa-paniers) : [{nom, quand, nb, total, articles:
   [{id, quantite}]}]. Photographie du panier courant, rechargement par
   AJOUT au panier courant (non destructif). Les libellés d'état des
   boutons sont commutés en CSS par data-etat, aucun texte côté JS. */
(function () {
  var CLE = 'alfa-paniers';

  function lire() {
    try { return JSON.parse(localStorage.getItem(CLE)) || []; }
    catch (e) { return []; }
  }

  function ecrire(paniers) {
    try { localStorage.setItem(CLE, JSON.stringify(paniers)); } catch (e) {}
  }

  function etat(bouton, valeur) {
    bouton.setAttribute('data-etat', valeur);
    setTimeout(function () { bouton.removeAttribute('data-etat'); }, 2000);
  }

  function rendre() {
    var conteneur = document.querySelector('[data-paniers-conteneur]');
    if (!conteneur) return;
    var modele = document.querySelector('[data-paniers-modele]');
    var vide = document.querySelector('[data-paniers-vide]');
    var paniers = lire();
    conteneur.textContent = '';
    if (vide) vide.hidden = paniers.length > 0;
    if (!modele) return;
    paniers.forEach(function (panier, index) {
      var noeud = modele.content.cloneNode(true);
      noeud.querySelector('article').setAttribute('data-paniers-index', String(index));
      noeud.querySelector('[data-modele-nom]').textContent = panier.nom;
      var meta = [];
      if (panier.quand) {
        var d = new Date(panier.quand);
        if (!isNaN(d)) meta.push(d.toLocaleDateString(document.documentElement.lang || 'fr', { day: 'numeric', month: 'long', year: 'numeric' }));
      }
      meta.push(panier.nb + ' × · ' + (panier.total / 100).toFixed(2) + ' $');
      noeud.querySelector('[data-modele-meta]').textContent = meta.join(' — ');
      conteneur.appendChild(noeud);
    });
  }

  document.addEventListener('click', function (e) {
    var sauver = e.target.closest('[data-paniers-sauver]');
    if (sauver) {
      sauver.disabled = true;
      alfaRequete('/cart.js', { accept: 'application/json' }).then(function (r) {
        sauver.disabled = false;
        if (!r.ok) { etat(sauver, 'vide'); return; }
        var cart = r.json();
        if (!cart.item_count) { etat(sauver, 'vide'); return; }
        var paniers = lire();
        var d = new Date();
        paniers.unshift({
          nom: (document.documentElement.lang === 'fr' ? 'Épicerie du ' : 'Groceries — ') +
               d.toLocaleDateString(document.documentElement.lang || 'fr', { day: 'numeric', month: 'long' }),
          quand: d.toISOString(),
          nb: cart.item_count,
          total: cart.total_price,
          articles: cart.items.map(function (i) { return { id: i.variant_id, quantite: i.quantity }; })
        });
        ecrire(paniers);
        etat(sauver, 'ok');
        rendre();
      }).catch(function () { sauver.disabled = false; etat(sauver, 'vide'); });
      return;
    }

    var supprimer = e.target.closest('[data-paniers-supprimer]');
    if (supprimer) {
      var art = supprimer.closest('[data-paniers-index]');
      var index = parseInt(art.getAttribute('data-paniers-index'), 10);
      var paniers = lire();
      paniers.splice(index, 1);
      ecrire(paniers);
      rendre();
      return;
    }

    var recharger = e.target.closest('[data-paniers-recharger]');
    if (recharger) {
      var article = recharger.closest('[data-paniers-index]');
      var i = parseInt(article.getAttribute('data-paniers-index'), 10);
      var panier = lire()[i];
      if (!panier || !panier.articles.length) return;
      recharger.disabled = true;
      alfaRequete('/cart/add.js', {
        method: 'POST',
        json: { items: panier.articles.map(function (a) { return { id: a.id, quantity: a.quantite }; }) },
        accept: 'application/json'
      }).then(function (r) {
        recharger.disabled = false;
        etat(recharger, r.ok ? 'ok' : 'erreur');
        // Même en 422 (produit retiré du catalogue), une partie des articles
        // a pu entrer : on rafraîchit les compteurs dans tous les cas.
        if (window.alfaMajPanier) window.alfaMajPanier();
        if (r.ok) document.dispatchEvent(new CustomEvent('alfa:carte-ajout', { detail: { bouton: recharger } }));
      }).catch(function () {
        recharger.disabled = false;
        etat(recharger, 'erreur');
        if (window.alfaMajPanier) window.alfaMajPanier();
      });
    }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === CLE) rendre();
  });

  rendre();
})();

/* Tiroir-panier + FAB — mécanique maison (ressuscite le slide-cart
   décommissionné). Ouverture par le FAB ou par les liens panier des
   barres (data-tiroir-ouvrir, preventDefault seulement si le tiroir
   existe : sans JS ils restent des liens vers /cart). Quantités par
   /cart/change.js sur la clé de ligne — la réponse est le panier à
   jour, on re-rend depuis elle (aucune requête de plus). */
(function () {
  var tiroir = document.querySelector('[data-tiroir]');
  if (!tiroir) return;
  var voile = document.querySelector('[data-tiroir-voile]');
  var conteneur = tiroir.querySelector('[data-tiroir-articles]');
  var modele = tiroir.querySelector('[data-tiroir-modele]');
  var vide = tiroir.querySelector('[data-tiroir-vide]');
  var pied = tiroir.querySelector('[data-tiroir-pied]');
  var sousTotal = tiroir.querySelector('[data-tiroir-soustotal]');
  var declencheur = null;
  var occupe = false;

  function argent(cents) { return (cents / 100).toFixed(2) + ' $'; }

  function rendre(cart) {
    conteneur.textContent = '';
    var plein = cart.item_count > 0;
    vide.hidden = plein;
    pied.hidden = !plein;
    if (plein) sousTotal.textContent = argent(cart.total_price);
    cart.items.forEach(function (item) {
      var noeud = modele.content.cloneNode(true);
      noeud.querySelector('.tiroir__ligne').setAttribute('data-tiroir-cle', item.key);
      var liens = noeud.querySelectorAll('[data-modele-lien]');
      for (var i = 0; i < liens.length; i++) liens[i].href = item.url;
      var image = noeud.querySelector('[data-modele-image]');
      if (item.image) {
        image.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_144x$1$2');
      } else { image.remove(); }
      noeud.querySelector('[data-modele-titre]').textContent = item.product_title;
      noeud.querySelector('[data-modele-prix]').textContent = argent(item.final_line_price);
      noeud.querySelector('[data-modele-qte]').textContent = item.quantity;
      conteneur.appendChild(noeud);
    });
  }

  function ouvrir(depuis) {
    declencheur = depuis || null;
    alfaRequete('/cart.js', { accept: 'application/json' }).then(function (r) {
      if (r.ok) rendre(r.json());
      tiroir.hidden = false;
      voile.hidden = false;
      /* Reflow synchrone plutôt que requestAnimationFrame (piège projet :
         rAF gelé en WebView inactive → tiroir resté hors-écran). */
      void tiroir.offsetWidth;
      tiroir.classList.add('tiroir--ouvert');
      document.documentElement.classList.add('tiroir-bloque');
      var fermer = tiroir.querySelector('.tiroir__fermer');
      if (fermer) fermer.focus();
    }).catch(function () {
      if (declencheur && declencheur.href) window.location = declencheur.href;
    });
  }

  function fermer() {
    tiroir.classList.remove('tiroir--ouvert');
    document.documentElement.classList.remove('tiroir-bloque');
    voile.hidden = true;
    setTimeout(function () { tiroir.hidden = true; }, 250);
    if (declencheur && declencheur.focus) declencheur.focus();
    declencheur = null;
  }

  function changer(cle, quantite, ligne) {
    if (occupe) return;
    occupe = true;
    if (ligne) ligne.classList.add('tiroir__ligne--occupee');
    alfaRequete('/cart/change.js', {
      method: 'POST',
      json: { id: cle, quantity: quantite },
      accept: 'application/json'
    }).then(function (r) {
      occupe = false;
      if (r.ok) rendre(r.json());
      else if (ligne) ligne.classList.remove('tiroir__ligne--occupee');
      if (window.alfaMajPanier) window.alfaMajPanier();
    }).catch(function () {
      occupe = false;
      if (ligne) ligne.classList.remove('tiroir__ligne--occupee');
    });
  }

  document.addEventListener('click', function (e) {
    var ouvreur = e.target.closest('[data-tiroir-ouvrir]');
    if (ouvreur) {
      e.preventDefault();
      ouvrir(ouvreur);
      return;
    }
    if (e.target.closest('[data-tiroir-fermer]')) {
      fermer();
      return;
    }
    var moins = e.target.closest('[data-tiroir-moins]');
    var plus = e.target.closest('[data-tiroir-plus]');
    if (moins || plus) {
      var ligne = e.target.closest('[data-tiroir-cle]');
      if (!ligne) return;
      var qte = parseInt(ligne.querySelector('[data-modele-qte]').textContent, 10) || 0;
      changer(ligne.getAttribute('data-tiroir-cle'), plus ? qte + 1 : Math.max(0, qte - 1), ligne);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !tiroir.hidden) fermer();
  });
})();
